<template>
    <div v-if="isVisible" class="cookie-check">
        <div class="container">
            <div class="row">
                <div class="column text-col" v-html="cookieNoticeHtml">
                </div>
                <div class="column btn-col">
                    <div class="accept-btn" @click="hide()" v-html="cookieNoticeAcceptHtml"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // this component gets removed in pdfs. pages/Pdf.vue
    export default {
        name: "cookie-popup",
        data() {
            return {
                // computed does not watch localstorage so it does not work
                isVisible: this.computeVisible()
            }
        },
        computed: {
            cookieNoticeHtml() {
                const translationKey = 'cookies.notice'
                const translated = this.$options.filters.lang(translationKey).replace(/<p>|<\/p>/g, '');

                return translationKey === translated ? 'By using this page you are accepting cookies, which we use only for technical and analytical purposes. <a href="https://home.edurio.com/cookies-policy">Read more</a>'
                : translated
            },
            cookieNoticeAcceptHtml() {
                const translationKey = 'cookies.ack'
                const translated = this.$options.filters.lang(translationKey)

                return translationKey === translated ? 'OK'
                    : translated
            }
        },
        methods: {
            hide() {
                localStorage.setItem('cookie-notice', 1)
                this.isVisible = false;
                document.querySelector("body").classList.remove("cookie-popup-visible")
                this.$forceUpdate()
            },
            computeVisible() {
                // edurio/wiki#5462 - there are no translations in superadmin
                if (window.superadmin) {
                    return false;
                }

                const isVisible = (
                    localStorage === undefined ||
                    localStorage === null ||
                    localStorage.getItem('cookie-notice') === null
                )

                if (isVisible) {
                    document.querySelector("body").classList.add("cookie-popup-visible")
                }

                return isVisible;
            }
        }
    }
</script>

<style lang="scss">
    .cookie-check {
        z-index: 1000;
        position: relative;
        width: 100%;
        background: $black-1;
    }

    .cookie-check .row {
        display: flex;
        margin: 0;
        align-items: center;
    }

    .cookie-check a {
        color: #fff;
        text-decoration: underline;
    }

    .cookie-check .text-col {
        flex: 9;
        padding-left: 12px;
        color: #ffffff;
        font-size: 14px;
        line-height: 19px;
    }

    .cookie-check .btn-col {
        flex: 3;
        padding-right: 12px;
    }

    .cookie-check .accept-btn {
        width: fit-content;
        height: 42px;
        margin: 20px 0 20px auto;
        padding: 0 24px;
        border-radius: 3px;
        font-size: 14px;
        line-height: 42px;
        text-align: center;
        color: #ffffff;
        background: $green;
        cursor: pointer;
    }

    .cookie-check .accept-btn:hover {
        opacity: 0.8;
        color: #ffffff;
    }

    @media (max-width: 767px) {
        .cookie-check .row {
            flex-direction: column;
        }

        .cookie-check .text-col {
            flex: 12;
            padding: 12px 12px 0;
            text-align: center;
        }
        .cookie-check .btn-col {
            padding: 0;
        }

        .cookie-check .accept-btn {
            margin: 12px auto 16px;
        }
    }

    .text-col >>> a {
        color: white !important;
        text-decoration: underline;
    }
</style>
